import { useMemo } from 'react';

import { useAuth } from 'modules/auth/hooks/useAuth';
import { useUser } from 'modules/user/hooks/useUser';
import { useEmailData } from 'modules/auth/hooks/useEmailData';

import { getAccountName } from '../utils/getAccountName';

export const usePersonalAccountButton = () => {
  const { confirmedEmail } = useEmailData();
  const { address, email, nickname } = useUser();
  const { authProvider, isGoogleAuth, isOAuth } = useAuth();

  const accountName = useMemo(() => {
    // for auth0 we should always use email from userAccount store
    // confirmed email is used for case when user with google provider changed email
    const accountEmail = isGoogleAuth ? confirmedEmail || email : email;

    return getAccountName({
      address,
      authProvider,
      email: accountEmail,
      isOAuth,
      nickname,
    });
  }, [
    isGoogleAuth,
    confirmedEmail,
    email,
    address,
    authProvider,
    isOAuth,
    nickname,
  ]);

  return { accountName };
};
